import { render } from "./loadscript.vue?vue&type=template&id=3b206409"
import script from "./loadscript.vue?vue&type=script&lang=js"
export * from "./loadscript.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__